// @ts-strict-ignore
// used with nextJS - grab optimized file from contentful
export function contentfulLoader({ src }) {
  if (src.endsWith("?fm=webp")) return `https:${src}`;
  return `https:${src}?fm=webp`;
}

export function contentfulLoaderSterile({ src }) {
  return `https:${src}`;
}

export function handleContentfulLoader({
  src = "",
  width,
  quality,
  format = "webp"
}: {
  src: string;
  width?: number;
  quality?: number;
  format?: "webp" | "avif";
}) {
  const fileExtension = src.split(".").pop();
  if (!src.startsWith("https:")) src = `https:${src}`;

  if (fileExtension === "svg") {
    return src;
  }

  const url = new URL(src);
  url.searchParams.set("fm", format);
  if (width) url.searchParams.set("w", width.toString());
  if (quality) url.searchParams.set("q", quality.toString());
  return url.href;
}
